import { isSafari } from "../model/helpers/BrowserHelper";

let googlePayLoaded = false;

export function loadGooglePayScript(): Promise<void> {
    return new Promise((resolve, reject) => {
        if (googlePayLoaded || isSafari) return resolve();

        const script = document.createElement("script");
        script.src = "https://pay.google.com/gp/p/js/pay.js";
        script.async = true;
        script.onload = () => {
            googlePayLoaded = true;
            console.log("Google Pay script loaded");
            resolve();
        };
        script.onerror = () => reject(new Error("Google Pay script load failed"));

        document.body.appendChild(script);
    });
}
